import { MenuControllerId, MenuItem } from '@adaptiva/core/menus';
import { EJavaClassNames, ServerObjectMenuController } from '@adaptiva/data-service';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of, take } from 'rxjs';
import { CloudRelayServer } from '../../java';

@Injectable()
export class CloudRelayServerMenuController extends ServerObjectMenuController<CloudRelayServer> {

	public static override readonly id: MenuControllerId.Any = `${MenuControllerId.Prefix.Default}${EJavaClassNames.CloudRelayServer}`;

	public override readonly editMenuName: string = 'Edit Server';

	public override getClassName(): string {
		return EJavaClassNames.CloudRelayServer;
	}

	public override generate(_cloudRelayServer: CloudRelayServer): Observable<MenuItem<CloudRelayServer>[]> {
		return of([
			this.getShowReferencesMenuItem(_cloudRelayServer),
			this.getExportMenuItem(_cloudRelayServer),
			this.getManagePermissionsMenuItem(_cloudRelayServer),
			this.getDeleteMenuItem(_cloudRelayServer),
			this.getEditMenuItem(_cloudRelayServer)
		]);
	}

	protected override getEditMenuItem(_object: CloudRelayServer): MenuItem<CloudRelayServer> {
		const _itemId: string = this.hashItem(this.editMenuName, _object);
		const _item: MenuItem<CloudRelayServer> = this.getItem(_itemId, _object) || this.createItem({
			id: _itemId,
			name: this.editMenuName,
			data: _object,
			isDisabled: new BehaviorSubject(true),
			onSelect: this.edit.bind(this),
		});

		this.enableEdit(_item);

		return _item;
	}

	protected override enableEdit(_item: MenuItem<CloudRelayServer>): void {
		const _isVisible: boolean = !!_item.data.objectId &&
			this.permissions.hasReadPermissions(_item.data);

		_item.isVisible.next(_isVisible);

		if (_isVisible)
			_item.isDisabled.next(!this.permissions.hasWritePermissions(_item.data));
	}

	protected override edit(_item: MenuItem<CloudRelayServer>): void {
		this.overlays.load({
			overlayId: 'CloudRelayDiscoveryModeActionOverlayComponent',
			context: this.summarize.generate(_item.data.javaClassName, _item.data)
		}).pipe(take(1)).subscribe();
	}

}
